/**
 * @readonly
 * @enum {string}
 */
export const TpmsTirePatterns = Object.freeze({
    ALL_SEASON: 'ALL_SEASON',
    SUMMER: 'SUMMER',
    WINTER: 'WINTER',
    LIGHT_MEDIUM_TRUCK: 'LIGHT_MEDIUM_TRUCK',
    PASSENGER: 'PASSENGER',
    PERFORMANCE: 'PERFORMANCE',
    TOURING: 'TOURING'
})
